import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { InterviewQuestionsEditForm } from '../components/vacancies/InterviewQuestionsEditForm';
import { useVacancyStore } from '../store/vacancyStore';

export default function InterviewQuestionsEditPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { setSelectedVacancyById } = useVacancyStore();

  const vacancyId = id ? parseInt(id, 10) : null;

  const handleBack = () => {
    // Возвращаемся на страницу интервью
    navigate('/recruiter/interviews');
  };

  const handleSaveSuccess = (updatedVacancyId: number) => {
    console.log('InterviewQuestionsEditPage: Вопросы обновлены для вакансии ID:', updatedVacancyId);

    // Устанавливаем вакансию как выбранную
    setSelectedVacancyById(updatedVacancyId);

    // Возвращаемся на страницу интервью
    navigate('/recruiter/interviews');
  };

  if (!vacancyId) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-[var(--text-dark)] text-[16px]">
          Неверный ID вакансии
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#f5f6f1] min-h-screen py-8">
      <div className="w-full max-w-full px-6">
        <InterviewQuestionsEditForm
          vacancyId={vacancyId}
          onBack={handleBack}
          onSaveSuccess={handleSaveSuccess}
        />
      </div>
    </div>
  );
}
